import { render, staticRenderFns } from "./account_xq.vue?vue&type=template&id=6730e462&scoped=true&"
import script from "./account_xq.vue?vue&type=script&lang=js&"
export * from "./account_xq.vue?vue&type=script&lang=js&"
import style0 from "./account_xq.vue?vue&type=style&index=0&id=6730e462&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6730e462",
  null
  
)

export default component.exports